import React from 'react';
import { Layout } from '../../components/Layout';
import { Checklist } from '../../components/Checklist';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { IR_ACCOUNT_CHECKLIST } from '../../utils/constants';
import { AlertTriangle, ShieldAlert, ArrowRight, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AccountTakeover() {
  return <Layout data-id="element-3713">
      <div className="container mx-auto px-4 py-12" data-id="element-3714">
        <div className="mb-12 border-b border-slate-800 pb-8" data-id="element-3715">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-red-500/10 text-red-400 text-xs font-medium mb-4 border border-red-500/20" data-id="element-3716">
            <ShieldAlert className="h-3 w-3 mr-2" data-id="element-3717" />
            Incident Response Playbook
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-3718">
            Account Takeover (ATO)
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-3719">
            Emergency procedures when email, social media, or critical service
            accounts are compromised by hackers.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-3720">
          <div className="lg:col-span-2 space-y-12" data-id="element-3721">
            <section data-id="element-3722">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-3723">
                <Clock className="h-6 w-6 text-red-500 mr-3" data-id="element-3724" />
                First 24 Hours (Critical)
              </h2>
              <div className="space-y-6" data-id="element-3725">
                <div className="bg-slate-900/50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-3726">
                  <h3 className="text-xl font-bold text-slate-100 mb-2" data-id="element-3727">
                    1. Isolate & Revoke Access
                  </h3>
                  <p className="text-slate-400 mb-4" data-id="element-3728">
                    Immediately login (if still possible) and find "Logged in
                    devices" or "Sessions" menu.
                  </p>
                  <ul className="list-disc list-inside text-slate-300 space-y-1" data-id="element-3729">
                    <li data-id="element-3730">Force logout all sessions (Kill all sessions).</li>
                    <li data-id="element-3731">Change password immediately to a new & unique one.</li>
                  </ul>
                </div>

                <div className="bg-slate-900/50 p-6 rounded-lg border-l-4 border-orange-500" data-id="element-3732">
                  <h3 className="text-xl font-bold text-slate-100 mb-2" data-id="element-3733">
                    2. Check for Backdoors
                  </h3>
                  <p className="text-slate-400 mb-4" data-id="element-3734">
                    Hackers often leave backdoors to regain access.
                  </p>
                  <ul className="list-disc list-inside text-slate-300 space-y-1" data-id="element-3735">
                    <li data-id="element-3736">
                      Check Email Forwarding rules (often set to intercept OTP).
                    </li>
                    <li data-id="element-3737">
                      Check Recovery Email/Phone (ensure they're not the
                      hacker's).
                    </li>
                    <li data-id="element-3738">
                      Check Authorized Apps (remove unknown applications).
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <section data-id="element-3739">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 text-red-400" data-id="element-3740">
                DO NOT
              </h2>
              <ul className="space-y-3 text-slate-400" data-id="element-3741">
                <li className="flex items-start" data-id="element-3742">
                  <AlertTriangle className="h-5 w-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-3743" />
                  <span data-id="element-3744">
                    Panic and attempt repeated logins (may result in permanent
                    lockout).
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3745">
                  <AlertTriangle className="h-5 w-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-3746" />
                  <span data-id="element-3747">
                    Delete evidence (logs/notification emails) before
                    documentation.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3748">
                  <AlertTriangle className="h-5 w-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-3749" />
                  <span data-id="element-3750">
                    Pay ransom without guarantee (for ransomware/sextortion
                    cases).
                  </span>
                </li>
              </ul>
            </section>
          </div>

          <div className="space-y-6" data-id="element-3751">
            <Checklist id="ir-ato-checklist" title="Response Checklist" items={IR_ACCOUNT_CHECKLIST} data-id="element-3752" />
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-3753">
              <h3 className="font-bold text-slate-100 mb-4" data-id="element-3754">
                Related Playbooks
              </h3>
              <div className="space-y-3" data-id="element-3755">
                <Link to="/ir/lost-device" data-id="element-3756">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-3757">
                    Lost Device Protocol
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-3758" />
                  </Button>
                </Link>
                <Link to="/personal/identity" data-id="element-3759">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-3760">
                    Prevent Future Attacks
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-3761" />
                  </Button>
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}